import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const bestHomeFixPicksStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-[#3B82F6]',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white [&>path]:stroke-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-[#3B82F6]',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#78A707] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-[#E0FEE0]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#9747FF]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#65A30D]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-white',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-white',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#FB923C] hover:border-[#FB923C] hover:bg-[#FB923C] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#FB923C]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-[#3B82F6]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#3B82F6]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#65A30D]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#3B82F6] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#3B82F6] text-[#3B82F6] [&>svg>path]:stroke-[#3B82F6] [&>svg>g>path]:stroke-[#3B82F6] [&>svg>path]:fill-[#3B82F6] [&>svg>g>path]:fill-[#3B82F6]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#3B82F6]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#3B82F6]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#E0FEE0]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#65A30D]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#E0FEE0]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#3B82F6] [&>.explore-icon-fill]:!fill-[#E0FEE0] [&>g>.explore-icon-fill]:!fill-[#E0FEE0]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#E0FEE0] [&>.vector-top>path]:fill-[#3B82F6] [&>.vector-bottom>path]:fill-[#3B82F6]',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#65A30D]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#ECFCCB]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-[#171717]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#65A30D]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-white',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#65A30D]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-white',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#65A30D]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#65A30D]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#1D4ED8]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#2C0065] ',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#2C0065]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#1D4ED8]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-white ',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:fill-white',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#171717]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#3B82F6] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#3B82F6] text-[#3B82F6] [&>svg>path]:stroke-[#3B82F6] [&>svg>g>path]:stroke-[#3B82F6] [&>svg>path]:fill-[#3B82F6] [&>svg>g>path]:fill-[#3B82F6]',
  LISTPAGE_BUTTON_LINK: 'text-[#3B82F6]',
  LISTPAGE_ANCHOR_LINK: 'text-[#3B82F6]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#3B82F6]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#3B82F6]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#3B82F6]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#3B82F6] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#3B82F6] text-[#3B82F6]  [&>svg>path]:stroke-[#3B82F6] [&>svg>g>path]:stroke-[#3B82F6] [&>svg>path]:fill-[#3B82F6] [&>svg>g>path]:fill-[#3B82F6]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#3B82F6]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#3B82F6]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#3B82F6]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#3B82F6]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-[#65A30D]',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#3B82F6]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#65A30D] [&>.vector-top>path]:fill-[#9DD41A] [&>.vector-bottom>path]:fill-[#9DD41A]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-[#F7F7F7]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#ECFCCB] [&>circle]:stroke-[#ECFCCB] [&>path]:fill-[#65A30D]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#ECFCCB]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#65A30D]',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:bg-[#458DFA4D] data-[focus]:text-black text-black',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'bg-[#458DFA99] text-black',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#458DFA]',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container',
}
